import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/api";
import { DEFAULT_BAREME } from "@/lib/salaireSimulator";

// Barème réglementaire en vigueur (Regulatory Engine) — repli sur DEFAULT_BAREME si l'API est indisponible.
export function useBareme(date) {
  const [state, setState] = useState({ values: DEFAULT_BAREME, meta: null, loading: true });
  useEffect(() => {
    let alive = true;
    axios.get(`${API}/public/regulatory/bareme`, { params: date ? { date } : {} })
      .then((r) => { if (alive) setState({ values: { ...DEFAULT_BAREME, ...(r.data.values || {}) }, meta: { at: r.data.at, ...r.data.meta }, loading: false }); })
      .catch(() => { if (alive) setState((s) => ({ ...s, loading: false })); });
    return () => { alive = false; };
  }, [date]);
  return state;
}
